exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chronopost__summary[data-v-78a1c087]{margin-bottom:20px;padding:10px 14px;border-left:3px solid #1ab394;background-color:rgba(26,179,148,.06);border-radius:0 3px 3px 0;font-size:13px;line-height:1.5;color:#5e6366}.chronopost__summary i[data-v-78a1c087]{margin-right:6px;color:#1ab394}.chronopost__summary strong[data-v-78a1c087]{color:#333}.chronopost__summary-loading[data-v-78a1c087]{color:#999;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78a1c087","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TransportRate/ChronopostSetting.vue
// module id = 1021
// module chunks = 0